import React, { useState, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import {
  FacebookIcon,
  FacebookShareButton,
  InstapaperShareButton,
  InstapaperIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';

import { ResponsiveContext } from '../../App';
import { Simulation } from '../../types/main';
import { creeClassNamesZoneSaisie, codeShareCode } from '../../utils/utils';

import { SaisieContext } from '../formConteneur';
import { BoutonFaireUneSimu } from '../boutons/FB/boutonFaireUneSimu';

interface BilanData {
  points: number;
  nbTotalPoints: number;
  filiere: string;
}
export const Bilan: React.FC = () => {
  // const { etapeSaisie, etapesSaisie } = useContext(EtapesSaisieContext);
  const { values, setFieldValue } = useFormikContext();
  const { modeAffichage, setBoutonSuivant } = useContext(SaisieContext);
  const simulation = values as Simulation ;
  const { points, nbTotalPoints, filiere } = simulation;
  const { dimensions } = useContext(ResponsiveContext);
  const classNamesZoneSaisie = creeClassNamesZoneSaisie(dimensions.largeur, 4);
  classNamesZoneSaisie.push('bilan');
  const [urlPartage, setUrlPartage] = useState('http://simubac2020.fr');
  const [fromFB, setFromFB] = useState(false);

  const createAndSetUrlPartage = (): string => {
    const searchString = codeShareCode(points, nbTotalPoints, filiere);
    // let ret = `http://simubac2020.fr/?code=${searchString}`;
    let ret = `http://raf-prag.com/?code=${searchString}`;
    // alert(ret);
    // RETIRER iframe si plus dans iframe
    // let ret = `http://raf-prag.com/?p=${points}&n=${nbTotalPoints}&f=${filiere}`;
    // let ret = `http://simubac2020.fr/?p=${points}&n=${nbTotalPoints}&f=${filiere}`;
    setUrlPartage(ret);
    return ret;
  }

  
  useEffect(() => {
    if (window.location.search.length === 0) {
      setFromFB(false);
      createAndSetUrlPartage();
    } else {
      // window.history.pushState(null, '', 'http://raf-prag.com/iframe');
      setFromFB(true);
    }
    setBoutonSuivant('non');
  }, [])

  let phrase;
  let mention;
  let mentionAvecEmoji;
  let classeMention;
  let quoteFB;
  let ratio = points / nbTotalPoints;

  if (ratio >= 16 / 20) {
    phrase = 'Vous seriez ADMIS au baccalauréat avec la mention TRES BIEN.';
    mention = 'MENTION TRES BIEN !';
    mentionAvecEmoji = mention + ' \u{1F973}'; // 🥳
    quoteFB = `Regarde, j'aurais le bac avec ${mention}`;
    classeMention = 'vert';
  } else if (ratio >= 14 / 20) {
    phrase = 'Vous seriez ADMIS au baccalauréat avec la mention BIEN.';
    mention = 'MENTION BIEN !';
    mentionAvecEmoji = mention + ' \u{1F60E}'; // 😎
    quoteFB = `Regarde, j'aurais le bac avec ${mention}`;
    classeMention = 'vert';
  } else if (ratio >= 12 / 20) {
    phrase = 'Vous seriez ADMIS au baccalauréat avec la mention ASSEZ BIEN.';
    mention = 'MENTION ASSEZ BIEN !';
    mentionAvecEmoji = mention + ' \u{1F920}'; // 🤠
    quoteFB = `Regarde, j'aurais le bac avec ${mention}`;
    classeMention = 'vert';
  } else if (ratio >= 10 / 20) {
    phrase = 'Vous seriez ADMIS au baccalauréat.';
    mention = 'ADMIS';
    mentionAvecEmoji = mention + ' \u{1F44C}'; // 👌
    quoteFB = `Regarde, j'aurais le bac !`;
    classeMention = 'vert';
  } else if (ratio >= 8 / 20) {
    phrase = <>Vous seriez admis à passer les oraux de rattrapage début juillet 2020, à savoir 2 épreuves orales sur 2 matières au choix et dont les notes remplaceront le notes de contrôle continu des matières concernées.<br /><br />Toutefois si votre note est proche de 10, le jury de concours pourra examiner votre livret scolaire et vous accorder le baccalauréat sans avoir à passer les oraux.</>;
    mention = 'ORAL...';
    mentionAvecEmoji = mention + ' \u{1F644}'; // 😳
    quoteFB = `Qui veut bien me donner un coup de main pour avoir mon bac ?`;
    classeMention = 'orange';
  } else {
    phrase = <>Vous n'auriez pas le baccalauréat lors de la session de juin 2020, en revanche, vous auriez la possibilité de passer le bac à la session de septembre.<br/><br/>Toutefois si votre note est proche de 8, le jury de concours pourra examiner votre livret scolaire et vous autoriser à passer les oraux de rattrapage début juillet 2020.</>;
    mention = '';
    mentionAvecEmoji = '';
    quoteFB = `C'est vraiment grave dans la vie de ne pas avoir son bac ?`;
    classeMention = '';
  }

  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
    >
      <div className="col1">
        <div className="col">
          <h1 className="titre">Résultat...</h1>
          {mention !== '' && 
            <h1 className={classeMention}>{mentionAvecEmoji}</h1>
          }
          {!fromFB && <div className="share">
            <div className="">
              <div className="textePartagerSurFB"><div>Partager</div></div>
              <div className="iconeFB">
                <FacebookShareButton
                  url={urlPartage}
                  quote={quoteFB}
                >
                  <FacebookIcon round={true} />
                </FacebookShareButton>
              </div>
              <div className="iconeTwitter">
                <TwitterShareButton
                  url={urlPartage}
                  title={quoteFB}
                  hashtags={['bac2020', 'confinement']}
                >
                  <TwitterIcon round={true} />
                </TwitterShareButton>
              </div>
              <div className="iconeWA">
                <WhatsappShareButton
                  url={urlPartage}
                  title={quoteFB}
                  separator={' - '}
                >
                  <WhatsappIcon round={true} />
                </WhatsappShareButton>
              </div>
            </div>
          </div>}
          <h2>{phrase}</h2>
          {fromFB && <BoutonFaireUneSimu />}
        </div>
      </div>
    </div>
  );
};
